import React from "react";
import { useIntl } from "react-intl";
import { formatPrice } from "../../engine/axes/priceFormat";
import useCrosshairBar from "../../hooks/useCrosshairBar";
import "./OhlcInfo.sass";

// Row order as in PO (05-ohlc-zoom-button.png)
const OHLC_ROWS = [
  { field: "open", labelId: "futures.chart.ohlc.open" },
  { field: "close", labelId: "futures.chart.ohlc.close" },
  { field: "high", labelId: "futures.chart.ohlc.high" },
  { field: "low", labelId: "futures.chart.ohlc.low" },
];

/**
 * Open, close, high and low of the bar under the crosshair, in the bottom
 * left corner of the chart (po-chart-visual-spec.md §6). Shown only while
 * the crosshair is over a bar; prices with the full precision of the pair.
 * Subscribes to the engine itself, so crosshair moves re-render only this block.
 *
 * @param {object} props
 * @param {object|null} props.engine - ChartEngine from useChartEngine
 */
const OhlcInfo = ({ engine }) => {
  const intl = useIntl();
  const crosshairBar = useCrosshairBar(engine);

  if (!crosshairBar) return null;

  const { bar, decimals } = crosshairBar;

  return (
    <dl className="ohlc-info">
      {OHLC_ROWS.map(({ field, labelId }) => (
        <div key={field} className="ohlc-info__row">
          <dt className="ohlc-info__label">{intl.formatMessage({ id: labelId })}:</dt>
          <dd className="ohlc-info__value">{formatPrice(bar[field], decimals)}</dd>
        </div>
      ))}
    </dl>
  );
};

export default OhlcInfo;
